import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GameListsComponent } from 'src/app/pages/game-lists/game-lists.component';
import { HelperFunctions } from 'src/app/services/helper-functions';
import { PartnerServicesService } from 'src/app/services/partner-service/partner-services.service';
import { SportServicesService } from 'src/app/services/sport-service/sport-services.service';
import { ValidateService } from 'src/app/services/ui/validate.service';
import { UserManagerService } from 'src/app/services/user-manager/user-manager.service';

@Component({
  selector: 'app-edit-payment-account',
  templateUrl: './edit-payment-account.component.html',
  styleUrls: ['./edit-payment-account.component.scss']
})
export class EditPaymentAccountComponent implements OnInit {
  SubmitTriggered = false;
  phone:any;
  inProgress: boolean;
  created = true;
  account_info: any ={};
  constructor(public sportService: SportServicesService,
              private translate: TranslateService,
              private partnerService: PartnerServicesService,
              private router: Router,
              private helperFunction: HelperFunctions,
              private validateService: ValidateService,
              private userService: UserManagerService,
              public dialogRef: MatDialogRef<GameListsComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.router.events.subscribe(val => {
      this.onNoClick();
    });
    this.account_info = this.data.account;
    // console.log(this.account_info)
  }
  editAccount() {
    this.SubmitTriggered = true;
    if (!this.account_info.account) {
      return;
    }
    let params: any = {};

    this.inProgress = true;
    // params.agentID = this.sportService.activeClientDetails.lgAgentID;
    params.phone = this.account_info.account;
    // params.provider = this.account_info.provider.id;

    this.partnerService.editPaymentAccount(this.account_info.accountId, params).then(res => {

      this.partnerService.checkOperation(res);

      this.created = true;
      this.onNoClick();
    }).catch(()=>{
      this.inProgress = false;
    });
  }
  onNoClick(): void {
    this.dialogRef.close(this.created);
  }
}
